export default __webpack_public_path__ + "assets/98bcb97373dd596a63c12a0f24caddaf.png";